import { FETCH_LOCALITIES_RADIUS_SUCCESS, FETCH_LOCALITIES_RADIUS_FAILURE, FETCH_LOCALITIES_RADIUS_START } from '../actions/radiusActions';

const initialState = {
  radiusLocalities: {},
  loading: false,
  error: null,
};

const localityradiusReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOCALITIES_RADIUS_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_LOCALITIES_RADIUS_SUCCESS:
      return {
        ...state,
        radiusLocalities: action.payload,
        error: null,
      };
    case FETCH_LOCALITIES_RADIUS_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default localityradiusReducer;